module.exports = __webpack_public_path__ + "static/media/16UNODC25.f2bbb7e4.jpg";